module.exports = __webpack_public_path__ + "static/media/bb_primary.6e8544b8.svg";